import {ActionFunctionArgs, Outlet, redirect, useLocation, useNavigate} from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import {
  AttendeeEdit,
  attendeeEditAction,
  attendeeEditLoader,
} from "./AttendeeEdit";
import {
  AttendeeCreate,
  attendeeCreateAction,
  attendeeCreateLoader,
} from "./AttendeeCreate";
import {
  AttendeeClone,
  attendeeCloneAction,
  attendeeCloneLoader,
} from "./AttendeeClone";
import { AttendeeList } from "./AttendeeList";
import { Attendee } from "../../types/attendee";
import { AttendeeShow } from "./AttendeeShow";
import toast from "react-hot-toast";
import {DELETE_ATTENDEE} from "./mutations";
import {createApolloClient} from "../../providers/ApolloClientFactory";

const client = createApolloClient();

const AttendeeIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/attendees") {
    navigate(`/attendees/list`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

const attendeeDeleteAction = async ({ params }: ActionFunctionArgs) => {
  const { id } = params;
  try {
    await client.mutate({
      mutation: DELETE_ATTENDEE,
      variables: { id },
    });
    toast.success("Attendee Deleted");
    return redirect(`/attendees/list`);
  } catch (error) {
    toast.error("Failed to delete attendee: " + error);
    return null;
  }
};

export const attendeesRouter = {
  path: "/attendees",
  id: "attendees",
  element: <AttendeeIndex />,
  handle: {
    crumb: () => <Breadcrumb name="Attendee" href="/attendees/list" />,
  },
  // loader: requireAuth(ADMIN_ORGANIZER),
  children: [
    {
      path: "list",
      id: "attendees-list",
      element: <AttendeeList />,
    },
    {
      path: "create",
      id: "attendees-create",
      element: <AttendeeCreate />,
      loader: attendeeCreateLoader,
      action: attendeeCreateAction,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Create Attendee"
            href="/attendees/create"
          />
        ),
      },
    },
    {
      path: ":id",
      id: "attendees-show",
      element: <AttendeeShow />,
    },
    {
      path: ":id/edit",
      id: "attendees-edit",
      element: <AttendeeEdit />,
      loader: attendeeEditLoader,
      action: attendeeEditAction,
      handle: {
        crumb: (data: { attendee: Attendee }) => (
          <Breadcrumb
            name={`Edit ${data.attendee.first_name} ${data.attendee.last_name}`}
            href={`/attendees/${data.attendee.id}/edit`}
          />
        ),
      },
    },
    {
      path: ":id/clone",
      id: "attendees-clone",
      element: <AttendeeClone />,
      loader: attendeeCloneLoader,
      action: attendeeCloneAction,
      handle: {
        crumb: (data: { attendee: Attendee }) => (
          <Breadcrumb
            name={`Clone ${data.attendee.first_name} ${data.attendee.last_name}`}
            href={`/attendees/${data.attendee.id}/clone`}
          />
        ),
      },
    },
    {
      path: ":id/delete",
      id: "attendees-delete",
      action: attendeeDeleteAction,
    },
  ],
};
